import { Module, Mutation } from 'vuex-module-decorators'
import BaseStore from '@/store/BaseStore'

export interface modalAlertParameterInterface {
  modalType?: string
  isUseOk?: boolean
  onOkClick?: any
  onCancelClick?: any
  onRemoveClick?: any
  addButtons?: ModalAlertAddButton[]
}

export interface ModalAlertAddButton {
  label: string
  primary?: boolean
  onClick: Function
}

@Module({
  name: 'ModalAlertStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalAlertStore extends BaseStore {
  _isOpen: boolean = false

  _okCallback: any

  _cancelCallback: any

  _removeCallback: any

  _modalType: string = ''

  // ボタン「OK」は大体の状況で使用するので「true」を初期値とする
  _isUseOk: boolean = true

  _addButtons: ModalAlertAddButton[] = []

  get isOpen(): boolean {
    return this._isOpen
  }

  get modalType(): string {
    return this._modalType
  }

  get isUseOk(): boolean {
    return this._isUseOk
  }

  get addButtons(): ModalAlertAddButton[] {
    return this._addButtons
  }

  @Mutation
  public open(params?: modalAlertParameterInterface): void {
    this._isOpen = true
    this._modalType = params?.modalType ?? ''
    this._isUseOk = params?.isUseOk ?? true
    this._okCallback = params?.onOkClick
    this._cancelCallback = params?.onCancelClick
    this._removeCallback = params?.onRemoveClick
    this._addButtons =
      params?.addButtons?.map(addButton => ({
        label: addButton.label,
        primary: addButton.primary ?? false,
        onClick: addButton.onClick
      })) ?? []
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public ok(): void {
    const result = this._okCallback ? this._okCallback() : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }

  @Mutation
  public cancel(): void {
    this._modalType = ''
    const result = this._cancelCallback ? this._cancelCallback() : true
    if (result === false) {
      return
    }

    this._isOpen = false
  }

  @Mutation
  public remove(index: number): void {
    if (this._removeCallback) {
      this._removeCallback(index)
    }
  }
}
